//moment(new Date()).format("Do MMMM")
export const noticeAction = (notice,audience) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(notice);
      firestore
        .collection("notices")
        .add(  
          notice
        )
        .then(() => {
          dispatch({
            type: "ADD_NOTICE",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_NOTICE_ERR",
            err
          });
        });
    };
  };
  